import { Link } from './forgotten-password.styled'
import { useIntl } from 'react-intl'
import { func } from 'prop-types'

const ForgottenLink = ({ toggleForgottenDialog, ...props }) => {
	const { formatMessage } = useIntl()

	return (
		<Link component="span" variant="body1" onClick={() => toggleForgottenDialog(true)} {...props}>
			{formatMessage({ id: 'forms_forgotten_password_label' })}
		</Link>
	)
}

ForgottenLink.propTypes = {
	toggleForgottenDialog: func.isRequired,
}

export default ForgottenLink
